/* eslint-disable no-useless-escape */
import * as Yup from "yup";
import { states } from "./constants";
import moment from "moment";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { PERIOD_MODES } from "../components/internal/BulkUploadReports/PeriodSelector";

// const URLREGEX =
//   /(https?:\/\/(?:www\.|(?!www)[\w-]+\.)[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\S*|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\S*|https?:\/\/(?:www\.|(?!www)[a-zA-Z0-9]+\.)[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;

const URLREGEX =
  /\b((https?|ftp):\/\/)?([a-z0-9-]+\.)+[a-z]{2,6}(:[0-9]{1,5})?(\/\S*)?\b/;

// const MOBILE_REGEX =
//   /^(\+\d{1,2})?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(x\d+)?$/;

function validatePinCodeByState(state, pin) {
  if (state && pin) {
    const found = states.find((st) => st.value === state);
    const pinStart = pin?.toString().substring(0, 2);
    if (found && found.pinStart.includes(parseInt(pinStart, 10))) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

export const SampleSchema = Yup.object({
  oldPassword: Yup.string()
    .min(6, "Please enter 6 characters")
    .required("Old Password is required"),
  newPassword: Yup.string()
    .min(6, "Please enter 6 characters")
    .required("New Password is required"),
  confirmPassword: Yup.string()
    .required("Confirm Password is required")
    .min(6, "Password must be minimum 6 characters")
    .test("passwords-match", "Passwords do not match", function (value) {
      return this.parent.newPassword === value;
    }),
});

export const OfflinePaymentSchema = Yup.object({
  paymentType: Yup.string().trim().required("Payment type is required"),
  details: Yup.string().optional(),
});

export const EditProfileSchema = Yup.object({
  name: Yup.string().trim().required("Name is required"),
  /*
  mobile: Yup.string()
    .required("Phone number is required")
    .test(
      "is-valid-phone",
      "Please enter valid phone number",
      function (value) {
        if (!value) return false;

        try {
          const phoneNumber = parsePhoneNumberFromString(value);
          return phoneNumber?.isValid() || false;
        } catch {
          return false;
        }
      },
    ),
  */
  dob: Yup.date().nullable().required("Date of birth is required"),
  houseNumber: Yup.string().trim().required("Address is required"),
  locality: Yup.string().trim().required("Locality is required"),
  city: Yup.string().trim().required("City is required"),
  state: Yup.string().trim().required("State is required"),
  pin: Yup.number()
    .required("Pincode is required")
    .test("pincode", "PIN is required", async function (value) {
      if (value?.toString()?.length === 6) {
        return validatePinCodeByState(this.parent.state, value);
      } else {
        return false;
      }
    }),
  landmark: Yup.string().trim().required("Landmark is required"),
});

export const LoginEmailValidationSchema = Yup.object({
  email: Yup.string().email("Please enter valid email").required(),
  password: Yup.string()
    .min(6, "Please enter 8 characters")
    .required("Password is required"),
});

const NUMBER_REGEX = /^\d+(,\d+)*$/;
// const PASSWORD_REGEX =
//   /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/;

const validatePassword = (password) => {
  if (
    password.length < 8 ||
    !/[A-Z]/.test(password) ||
    !/[a-z]/.test(password) ||
    !/[0-9]/.test(password) ||
    !/[@#$%^&+*!=]/.test(password)
  ) {
    return false;
  }
  return true;
};

export const LoginMobileValidationSchema = Yup.object({
  mobile: Yup.string()
    .required("Phone number is required")
    .test(
      "is-valid-phone",
      "Please enter valid phone number",
      function (value) {
        if (!value) return false;

        try {
          const phoneNumber = parsePhoneNumberFromString(value);
          return phoneNumber?.isValid() || false;
        } catch {
          return false;
        }
      },
    ),
});

export const FAQValidationSchema = Yup.object({
  sections: Yup.array(
    Yup.object({
      question: Yup.string().trim().required("Question is mandatory"),
      answer: Yup.string().trim().required("Answer is mandatory"),
    }),
  ),
});
export const TutorialValidationSchema = Yup.object({
  tutorialUrl: Yup.string().trim().required("Tutorial Video is mandatory"),
});

export const UploadAgreementValidationSchema = Yup.object({
  agreement_url: Yup.string()
    .trim()
    .required("Agreement Document is mandatory"),
});

export const AddZoomLinkValidation = Yup.object({
  zoomLink: Yup.string()
    .trim()
    .required("Video call link is mandatory")
    .matches(URLREGEX, "please enter the valid video call link"),
  startDate: Yup.string().nullable().trim().required("Date is mandatory"),
  startTime: Yup.string()
    .nullable()
    .trim()
    .required("Time is mandatory")
    .test(
      "MIN_TIME",
      "Start time must be greater then current time",
      function (value) {
        const date = moment(new Date(this.parent.startDate)).format(
          "YYYY-MM-DD",
        );
        const time = moment(new Date(value)).format("HH:mm:ss");
        const selectedTime = moment(`${date} ${time}`);
        return moment(new Date(selectedTime)).isAfter(moment(new Date()));
      },
    ),
});

export const UploadSummaryValidationSchema = Yup.object({
  summary: Yup.string().trim().required("Agreement Summary is mandatory"),
});

export const refundScheme = Yup.object({
  payments: Yup.array(
    Yup.object({
      amount: Yup.string()
        .trim()
        .test(
          "amount test",
          "Refund amount should be lesser than original amount",
          function (value) {
            if (this.parent?.checked && this.parent.type === "partial") {
              value = value?.toString()?.split(",")?.join("");
              if (
                Number(value) <= 0 ||
                Number(value) > Number(this.parent?.cartItem?.fee?.discPrice)
              ) {
                return false;
              }
              return true;
            }
            return true;
          },
        )
        .typeError("Refund amount cannot be empty/zero"),
    }),
  ),
  comment: Yup.string().trim().required(),
});

export const AddHearingDateValidation = Yup.object({
  startDate: Yup.string().nullable(),
  startTime: Yup.string()
    .nullable()
    .trim()
    .test("startTime", "", function (value) {
      if (this?.parent?.startDate) {
        const matched = value?.startDate;
        if (matched) {
          return true;
        } else {
          if (!value)
            return this.createError({
              message: "Time is required",
              path: "startTime",
            });
        }
      }
    }),
  hearingType: Yup.string().trim().required("Hearing type is required"),
  remarks: Yup.string().trim().required("Remarks is required"),
});

export const AudioSplit = Yup.object({
  audioFileName: Yup.string().trim().required("Audio File Name is required"),
  sessionNo: Yup.string().trim().required("Session no is required"),
});

export const CreateTranscriber = Yup.object({
  name: Yup.string("Please enter valid phone number")
    .trim()
    .required("Name is required"),
  email: Yup.string()
    .email("Please enter valid email")
    .required("Email id is Required"),
  mobile: Yup.string()
    .required("Phone number is required")
    .test(
      "is-valid-phone",
      "Please enter valid phone number",
      function (value) {
        if (!value) return false;

        try {
          const phoneNumber = parsePhoneNumberFromString(value);
          return phoneNumber?.isValid() || false;
        } catch {
          return false;
        }
      },
    ),
  type: Yup.string(),
  changePassword: Yup.boolean(),
  password: Yup.string().when(["type", "changePassword"], {
    is: (type, changePassword) => type === "CREATE" || changePassword === true,
    then: (schema) =>
      schema
        .required("Password is required")
        .min(6, "Please enter 8 characters")
        .test(
          "password",
          "Password should have a minimum of 8 characters and 1 uppercase and 1 numeral and 1 special character",
          async function (value) {
            if (value?.toString()?.length) {
              return validatePassword(value);
            } else {
              return false;
            }
          },
        ),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export const ChangePasswordSchema = Yup.object({
  oldPassword: Yup.string()
    .min(6, "Please enter 6 characters")
    .required("Current Password is required"),
  newPassword: Yup.string()
    .required("Password is required")
    .min(6, "Please enter 8 characters")
    .test(
      "newPassword",
      "Password should have a minimum of 8 characters and 1 uppercase and 1 numeral and 1 special character",
      async function (value) {
        if (value?.toString()?.length) {
          return validatePassword(value);
        } else {
          return false;
        }
      },
    ),
  confirmPassword: Yup.string()
    .required("Confirm New Password is required")
    .min(6, "Password must be minimum 8 characters")
    .test("passwords-match", "Passwords do not match", function (value) {
      return this.parent.newPassword === value;
    }),
});

export const CreateGenericMeeting = Yup.object({
  name: Yup.string("Please enter valid phone number")
    .trim()
    .required("Name is required"),
  email: Yup.string()
    .email("Please enter valid email")
    .required("Email id is Required"),
});

export const AssigninBulkCaseId = Yup.object({
  startCaseId: Yup.string("Please enter number").required(
    "Please enter number",
  ),
  endCaseId: Yup.string("Please enter number").required("Please enter number"),
  exceptCaseIds: Yup.string()
    .notRequired()
    .matches(NUMBER_REGEX, "Only numbers separated by commas are allowed")
    .nullable(),
  // .required("Except case ids is required"),
});

export const CreateNeutrals = Yup.object({
  name: Yup.string("Please enter valid phone number")
    .trim()
    .required("Name is required"),
  email: Yup.string()
    .email("Please enter valid email")
    .required("Email id is Required"),
  mobile: Yup.string()
    .required("Phone number is required")
    .test(
      "is-valid-phone",
      "Please enter valid phone number",
      function (value) {
        if (!value) return false;

        try {
          const phoneNumber = parsePhoneNumberFromString(value);
          return phoneNumber?.isValid() || false;
        } catch {
          return false;
        }
      },
    ),
  type: Yup.string(),
  changePassword: Yup.boolean(),
  password: Yup.string().when(["type", "changePassword"], {
    is: (type, changePassword) => type === "CREATE" || changePassword === true,
    then: (schema) =>
      schema
        .required("Password is required")
        .min(6, "Please enter 8 characters")
        .test(
          "password",
          "Password should have a minimum of 8 characters and 1 uppercase and 1 numeral and 1 special character",
          async function (value) {
            if (value?.toString()?.length) {
              return validatePassword(value);
            } else {
              return false;
            }
          },
        ),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export const InvoiceValidationSchema = Yup.object({
  invoiceDescription: Yup.string().required("Invoice Description is required"),
  caseManagementLotRate: Yup.string()
    .trim()
    .required("Case Management Rate is required"),
  billingLot: Yup.string().trim().required("Billing Lot is required"),
  transcriptionLotRate: Yup.string()
    .trim()
    .required("Transcription Rate is required"),
  sessionStartTime: Yup.string()
    .nullable()
    .trim()
    .required("Session Start Time is required"),
  sessionEndTime: Yup.string()
    .nullable()
    .trim()
    .required("Session End Time is required"),
  mailId: Yup.string()
    .email("Please enter valid email")
    .required("Email is required"),
});

export const ConfirmArbitratorValidationSchema = Yup.object({
  url: Yup.array().of(
    Yup.object().shape({
      uploadType: Yup.string()
        .trim()
        .test(
          "documenttype_required",
          "Document Type is required",
          function (value) {
            if (!value) {
              return false;
            }
            return true;
          },
        ),
      url: Yup.string()
        .trim()
        .test("document_required", "Document is required", function (value) {
          if (!value) {
            return false;
          }
          return true;
        }),
    }),
  ),
});

export const ReopenCaseValidationSchema = Yup.object({
  counterClaimExtendTimeline: Yup.string().required(
    "Counter claim extend timeline is required",
  ),
});

export const GenerateInvoiceValidationSchema = Yup.object({
  feeType: Yup.string().required("Fees type is required"),
  amount: Yup.string()
    .trim()
    .test("amount test", "Amount cannot be empty/zero", function (value) {
      if (Number(value) <= 0) {
        return false;
      }
      return true;
    }),
  claimantPercentage: Yup.number()
    .min(0, "The number must be at least 0")
    .max(100, "The number must be at most 100")
    .required("Claimant percentage is required"),
});

export const NoticeGenerationSchema = Yup.object({
  // invoice

  partyId: Yup.string().test("partyId", "Party is required", function (value) {
    return (
      value ||
      this?.options?.parent?.noticeOptions === 3 ||
      this?.options?.parent?.noticeOptions === 6
    );
  }),

  templateCode: Yup.string()
    .test("templateCode", "Template code is required", function (value) {
      return (
        value ||
        this?.options?.parent?.noticeOptions === 3 ||
        this?.options?.parent?.noticeOptions === 5 ||
        this?.options?.parent?.noticeOptions === 6
      );
    })
    .test(
      "templateCode-specialchars",
      "Special characters are not allowed",
      function (value) {
        const { noticeOptions } = this?.options?.parent || {};
        if (noticeOptions === 1 && value) {
          return /^[A-Za-z0-9\- ]*$/.test(value);
        }
        return true; // Skip validation for other noticeOptions
      },
    ),

  noticeCategory: Yup.string()
    .test("noticeCategory", "Notice category is required", function (value) {
      return (
        value ||
        this?.options?.parent?.noticeOptions === 3 ||
        this?.options?.parent?.noticeOptions === 5 ||
        this?.options?.parent?.noticeOptions === 6
      );
    })
    .test(
      "noticeCategory-specialchars",
      "Special characters are not allowed",
      function (value) {
        const { noticeOptions } = this?.options?.parent || {};
        if (noticeOptions === 1 && value) {
          return /^[A-Za-z0-9\- ]*$/.test(value);
        }
        return true; // Skip validation for other noticeOptions
      },
    ),

  noticeCopyDesign: Yup.string().test(
    "noticeCopyDesign",
    "Notice copy design is required",
    function (value) {
      return value || this?.options?.parent?.noticeOptions !== 2;
    },
  ),

  noticeTemplate: Yup.string().test(
    "noticeTemplate",
    "Notice template is required",
    function (value) {
      return (
        value ||
        this?.options?.parent?.noticeOptions === 3 ||
        this?.options?.parent?.noticeOptions === 2 ||
        this?.options?.parent?.noticeOptions === 5 ||
        this?.options?.parent?.noticeOptions === 6
      );
    },
  ),

  excelTemplate: Yup.string().test(
    "excelTemplate",
    "Excel template is required",
    function (value) {
      return (
        value ||
        this?.options?.parent?.noticeOptions === 3 ||
        this?.options?.parent?.noticeOptions === 2 ||
        this?.options?.parent?.noticeOptions === 5 ||
        this?.options?.parent?.noticeOptions === 6
      );
    },
  ),

  lotNo: Yup.string().test(
    "excelTemplate",
    "Lot number is required",
    function (value) {
      return value || this?.options?.parent?.noticeOptions !== 2;
    },
  ),

  /*

  excelFile: Yup.string().test(
    "excelFile",
    "Excel template is required",
    function (value) {
      return value || this?.options?.parent?.noticeOptions !== 2;
    },
  ),

  */

  excelFile: Yup.string().test(
    "excelFile",
    "Excel template is required",
    function (value) {
      const { noticeOptions, typeOfSelect } = this.options.parent;

      if (noticeOptions === 2 && typeOfSelect === "excel") {
        return !!value;
      }

      return true;
    },
  ),

  fromCaseId: Yup.string().test(
    "fromCaseId",
    "From Case ID is required",
    function (value) {
      const { typeOfSelect, noticeOptions } = this?.options?.parent || {};

      if (typeOfSelect !== "caseIds" || noticeOptions !== 2) {
        return true;
      }

      if (!value) {
        return false;
      }

      return /^\d+$/.test(value);
    },
  ),

  toCaseId: Yup.string().test(
    "toCaseId",
    "To Case ID is required",
    function (value) {
      const { typeOfSelect, noticeOptions } = this?.options?.parent || {};

      if (typeOfSelect !== "caseIds" || noticeOptions !== 2) {
        return true;
      }

      if (!value) {
        return false;
      }

      return /^\d+$/.test(value);
    },
  ),

  exceptCaseIds: Yup.string().test(
    "exceptCaseIds",
    "Only numbers separated by commas are allowed",
    function (value) {
      const { typeOfSelect, noticeOptions } = this?.options?.parent || {};

      if (
        (typeOfSelect !== "caseIds" && typeOfSelect !== "lotNumber") ||
        noticeOptions !== 2 ||
        !value
      ) {
        return true;
      }

      return NUMBER_REGEX.test(value);
    },
  ),

  lotNumber: Yup.string().test(
    "lotNumber",
    "Lot number is required",
    function (value) {
      const { typeOfSelect, noticeOptions, lotNo } =
        this?.options?.parent || {};

      if (typeOfSelect !== "lotNumber" || noticeOptions !== 2) {
        return true;
      }

      return !!(value || lotNo);
    },
  ),

  contractNumbers: Yup.array().test(
    "contractNumbers",
    "Contract numbers are required",
    function (value) {
      const { typeOfSelect, noticeOptions } = this?.options?.parent || {};

      if (typeOfSelect !== "contractNumbers" || noticeOptions !== 2) {
        return true;
      }

      return Array.isArray(value) && value.length > 0;
    },
  ),

  // letter head name

  letterHeadName: Yup.string().test(
    "letterHeadName",
    "Letter head name is required",
    function (value) {
      return value || this?.options?.parent?.noticeOptions !== 3;
    },
  ),

  // addSignature: Yup.string().test(
  //   "addSignature",
  //   "Signature file is required",
  //   function (value) {
  //     return value || this?.options?.parent?.noticeOptions !== 6;
  //   }
  // ),

  addSignature: Yup.mixed().test(
    "addSignature",
    "Signature file is required and must contain sign in the filename",
    function (value) {
      const parent = this?.options?.parent;

      if (parent?.noticeOptions !== 6) return true;

      if (!value) return false;

      let fileName = "";
      if (typeof value === "string") {
        fileName = value;
      } else if (value?.name) {
        fileName = value.name;
      } else {
        return false;
      }

      return fileName.toLowerCase().includes("sign");
    },
  ),

  /*
  
  checkerId: Yup.string().test(
    "checkerId",
    "Checker is required",
    function (value) {
      return value || this?.options?.parent?.noticeOptions !== 2;
    },
  ),

  */

  /*

  lineSpacing: Yup.mixed().test(
    "is-number",
    "Must be a valid number",
    (value) => {
      if (typeof value === "string" && value.trim() !== "") {
        return !isNaN(value) && !isNaN(parseFloat(value));
      }
      return true; // Allow empty values
    },
  ),
  
  afterLineSpacing: Yup.mixed().test(
    "is-number",
    "Must be a valid number",
    (value) =>
      typeof value === "string" ? !isNaN(value) && value.trim() !== "" : true,
  ),
  topMargin: Yup.mixed().test("is-number", "Must be a valid number", (value) =>
    typeof value === "string" ? !isNaN(value) && value.trim() !== "" : true,
  ),
  bottomMargin: Yup.mixed().test(
    "is-number",
    "Must be a valid number",
    (value) =>
      typeof value === "string" ? !isNaN(value) && value.trim() !== "" : true,
  ),
  leftMargin: Yup.mixed().test("is-number", "Must be a valid number", (value) =>
    typeof value === "string" ? !isNaN(value) && value.trim() !== "" : true,
  ),
  rightMargin: Yup.mixed().test(
    "is-number",
    "Must be a valid number",
    (value) =>
      typeof value === "string" ? !isNaN(value) && value.trim() !== "" : true,
  ),
  headerDistance: Yup.mixed().test(
    "is-number",
    "Must be a valid number",
    (value) =>
      typeof value === "string" ? !isNaN(value) && value.trim() !== "" : true,
  ),
  footerDistance: Yup.mixed().test(
    "is-number",
    "Must be a valid number",
    (value) =>
      typeof value === "string" ? !isNaN(value) && value.trim() !== "" : true,
  ),
  fontSize: Yup.mixed().test("is-number", "Must be a valid number", (value) =>
    typeof value === "string" ? !isNaN(value) && value.trim() !== "" : true,
  ),

  */

  // headerImage: Yup.string().test(
  //   "headerImage",
  //   "Header image is required",
  //   function (value) {
  //     return value || this?.options?.parent?.noticeOptions !== 3;
  //   }
  // ),

  // footerImage: Yup.string().test(
  //   "footerImage",
  //   "Footet image is required",
  //   function (value) {
  //     return value || this?.options?.parent?.noticeOptions !== 3;
  //   }
  // ),
});

export const GenerateBunldeSchema = Yup.object({
  pageNumber: Yup.number()
    .nullable()
    .test(
      "pageNumber",
      "Size of a bundle should be less than or equal to 2000 pages",
      function (value) {
        if (!value || value === 0) return true; // no selection → no error

        return value <= 2000;
      },
    ),
});

export const MultipleHearingsSchema = Yup.object({
  startDate: Yup.string().nullable().trim().required("Date is required"),
  startTime: Yup.string().nullable().trim().required("Time is required"),
  hearingType: Yup.string().trim().required("Hearing type is required"),
  remarks: Yup.string().trim().required("Remarks is required"),
  startCaseId: Yup.string().trim().required("From case id is required"),
  // endCaseId: Yup.string().trim().required("End case id is required"),
  endCaseId: Yup.string()
    .trim()
    .required("End case id is required")
    .test("endCaseId", "You have entered same case id", function (value) {
      if (this?.parent?.startCaseId === this?.parent?.endCaseId) {
        return false;
      } else return true;
    }),
  exceptCaseIds: Yup.string()
    .notRequired()
    .matches(NUMBER_REGEX, "Only numbers separated by commas are allowed")
    .nullable(),
});

export const bulkUpdateValidationSchema = Yup.object({
  fromCaseId: Yup.string().when(["labelType", "typeOfLoad"], {
    is: (labelType, typeOfLoad) =>
      !(labelType === "withExcel" && typeOfLoad === "addressLabel"), // required unless both conditions match
    then: (schema) =>
      schema
        .required("From Case ID is required")
        .matches(/^\d+$/, "Please enter number"),
    otherwise: (schema) => schema.notRequired(),
  }),

  toCaseId: Yup.string().when(["labelType", "typeOfLoad"], {
    is: (labelType, typeOfLoad) =>
      !(labelType === "withExcel" && typeOfLoad === "addressLabel"),
    then: (schema) =>
      schema
        .required("To Case ID is required")
        .matches(/^\d+$/, "Please enter number"),
    otherwise: (schema) => schema.notRequired(),
  }),

  excel: Yup.mixed().when(["labelType", "typeOfLoad"], {
    is: (labelType, typeOfLoad) =>
      labelType === "withExcel" && typeOfLoad === "addressLabel",
    then: (schema) => schema.required("Excel file is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  expectCaseIds: Yup.string()
    .notRequired()
    .matches(NUMBER_REGEX, "Only numbers separated by commas are allowed")
    .nullable(),
  // .required("Except case ids is required"),
});

export const renameValidationSchema = Yup.object({
  preInputText: Yup.string().required("Prename is required"),
  excel: Yup.string().required("Excel file is required"),
  zip: Yup.string().required("Zip file is required"),
});

export const splitFileValidationSchema = Yup.object({
  excel: Yup.string().required("Excel file is required"),
  pdfFile: Yup.string().required("Pdf file is required"),
  partyId: Yup.string().required("Party id is required"),
});

export const reGenerateValidationSchema = Yup.object({
  excelFile: Yup.string().required("Excel file is required"),
});

export const renameImageValidationSchema = Yup.object({
  preInputText: Yup.string().required("Prename is required"),
  excelFile: Yup.string().required("Excel file is required"),
  zipFilePath: Yup.string().required("Zip file is required"),
});

export const createExcelValidationSchema = Yup.object({
  docxFile: Yup.string().required("Docx file is required"),
});

export const mergeUploadValidationSchema = Yup.object({
  excel: Yup.string().required("Contract No is required"),
  // noticeCategory: Yup.string().required("Notice Category is required"),
  zipFile1: Yup.string().required("Zip File is required"),
  zipFile2: Yup.string().required("Zip File is required"),
  partyId: Yup.string().required("Party id is required"),
});

export const bulkDownloadValidationSchema = Yup.object({
  partyId: Yup.string().required("Party id is required"),
});

export const caseUploadValidationSchema = Yup.object({
  claimantPartyId: Yup.string().required("Party id is required"),
  excelFile: Yup.string().required("Excel file is required"),
});

export const splitPdfValidationSchema = Yup.object({
  startText: Yup.string().required("Start text is required"),
  pdfFile: Yup.string().required("Pdf file is required"),
});

export const splitPageNumbersValidationSchema = Yup.object({
  pageNumber: Yup.string().required("Page numbers are required"),
  fileUrl: Yup.string().required("Pdf file is required"),
});

export const estampFileValidationSchema = Yup.object({
  mergedFilePath: Yup.string().required("Merged PDF file is required"),
  excelFile: Yup.string().required("Excel file is required"),
  estampFile: Yup.string().required("Estamp PDF file is required"),
});

export const podValidationSchema = Yup.object({
  zipFile: Yup.string().required("Zip file is required"),
  excelFile: Yup.string().required("Excel file is required"),
});

export const arbitratorValidationSchema = Yup.object({
  // name: Yup.string().required("Arbitrator name is required"),
  // email: Yup.string()
  //   .email("Please enter valid email")
  //   .required("Arbitrator email is required"),
  //   arbitratorExcel: Yup.string().required("Excel file is required"),

  meetingType: Yup.string(),

  name: Yup.string().when("meetingType", {
    is: "single",
    then: Yup.string().required("Arbitrator name is required"),
    otherwise: Yup.string().notRequired(),
  }),

  email: Yup.string().when("meetingType", {
    is: "single",
    then: Yup.string()
      .email("Please enter valid email")
      .required("Arbitrator email is required"),
    otherwise: Yup.string().notRequired(),
  }),

  arbitratorExcel: Yup.string().when("meetingType", {
    is: "bulk",
    then: Yup.string().required("Excel file is required"),
    otherwise: Yup.string().notRequired(),
  }),
});

export const signerGatewayValidationSchema = Yup.object({
  file: Yup.string().required("File file is required"),
  SignaturePosition: Yup.string().required("Signature position is required"),

  arbitratorName: Yup.string().when("typeOfAction", {
    is: "1",
    then: Yup.string().required("Arbitrator is required"),
    otherwise: Yup.string().notRequired(),
  }),

  neutralName: Yup.string().when("typeOfAction", {
    is: "0",
    then: Yup.string().required("Arbitrator Name is required"),
    otherwise: Yup.string().notRequired(),
  }),

  typeOfAction: Yup.string(),

  arbitratorEmailId: Yup.string().when("typeOfAction", {
    is: "0",
    then: Yup.string().required("Arbitrator Email is required"),
    otherwise: Yup.string().notRequired(),
  }),

  CustomizeCoordinates: Yup.string()
    .nullable()
    .matches(NUMBER_REGEX, "Only numbers separated by commas are allowed")
    .when("SignaturePosition", {
      is: "Customize",
      then: Yup.string().required("Customize Coordinates are required"),
      otherwise: Yup.string().notRequired(),
    }),
});

export const preUploadValidationSchema = Yup.object({
  excel: Yup.string().required("Excel file is required"),
  contractName: Yup.string().required("Contract number is required"),
  partyId: Yup.string().required("Party id is required"),
});

export const neutralBulkValidationSchema = Yup.object({
  name: Yup.string().when("mode", {
    is: "manual",
    then: (schema) => schema.required("Name is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  email: Yup.string().when("mode", {
    is: "manual",
    then: (schema) =>
      schema.email("Please enter valid email").required("Email is required"),
  }),

  mobile: Yup.string().when("mode", {
    is: "manual",
    then: (schema) =>
      schema
        .required("Phone number is required")
        .test(
          "is-valid-phone",
          "Please enter valid phone number",
          function (value) {
            if (!value) return false;
            try {
              const phoneNumber = parsePhoneNumberFromString(value);
              return phoneNumber?.isValid() || false;
            } catch {
              return false;
            }
          },
        ),
  }),

  fileUrl: Yup.string().when("mode", {
    is: "excel",
    then: (schema) => schema.required("Excel file is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export const respondentValidationSchema = Yup.object({
  respondentParties: Yup.array().of(
    Yup.object({
      name: Yup.string().trim().required("Name is required"),
      email: Yup.string()
        .trim()
        .email("Invalid email address")
        .required("Email is required"),
      mobile: Yup.string(),
      address: Yup.string(),
      respondentKind: Yup.string().oneOf(["individual", "organization"]),
    }),
  ),
});

/**
 * Given a Yup array path like "claimants_list[2].Email", returns the index.
 */
const indexFromPath = (path) => {
  const match = path.match(/\[(\d+)\]/);
  return match ? parseInt(match[1], 10) : -1;
};

/**
 * Call this inside Formik's `validate` prop to detect the same email or phone
 * appearing across claimants_list, respondents_list, and arbitrators_list.
 *
 * Returns a Formik-shaped errors object (or {}) so you can merge it with other
 * validation errors.
 *
 * Example usage:
 *   <Formik validate={(values) => validateNoDuplicatesAcrossParties(values)} …>
 */
export const validateNoDuplicatesAcrossParties = (values) => {
  const errors = {};

  const lists = {
    claimants_list: values.claimants_list || [],
    respondents_list: values.respondents_list || [],
    arbitrators_list: values.arbitrators_list || [],
  };

  const fields = ["Email", "Phone"];

  fields.forEach((field) => {
    // Build a map: normalised value → [{listName, index}]
    const occurrences = new Map();

    Object.entries(lists).forEach(([listName, items]) => {
      items.forEach((item, index) => {
        const raw = (item?.[field] || "").toString().trim().toLowerCase();
        if (!raw) return;
        if (!occurrences.has(raw)) occurrences.set(raw, []);
        occurrences.get(raw).push({ listName, index });
      });
    });

    // For every value that appears more than once (across any combination of lists)
    occurrences.forEach((places) => {
      if (places.length < 2) return;
      places.forEach(({ listName, index }) => {
        if (!errors[listName]) errors[listName] = [];
        if (!errors[listName][index]) errors[listName][index] = {};
        errors[listName][index][field] = `Duplicate ${
          field === "Email" ? "email address" : "phone number"
        } found across parties`;
      });
    });
  });

  return errors;
};

/**
 * Creates a Yup `.test()` config that marks a field as invalid when its value
 * duplicates another entry's same field inside the same FieldArray.
 *
 * @param {string} fieldKey   - The object key to compare ("Email" | "Phone")
 * @param {string} label      - Human-readable label for the error message
 */
const duplicateTest = (fieldKey, label) => ({
  name: `no-duplicate-${fieldKey.toLowerCase()}`,
  message: `Duplicate ${label} found`,
  test(value, ctx) {
    if (!value) return true; // let required() handle empty values

    // ctx.from[1] is the parent array context in Yup
    const siblings = ctx?.from?.[1]?.value;
    if (!Array.isArray(siblings)) return true;

    const normalised = value.trim().toLowerCase();
    const selfIndex = indexFromPath(ctx.path);

    const isDuplicate = siblings.some((sibling, idx) => {
      if (idx === selfIndex) return false;
      const sibVal = (sibling?.[fieldKey] || "")
        .toString()
        .trim()
        .toLowerCase();
      return sibVal === normalised;
    });

    if (isDuplicate) {
      return ctx.createError({
        message: `Duplicate ${label}: "${value}" is already used by another ${label === "email address" ? "contact" : "contact"} in this list`,
      });
    }

    return true;
  },
});

/**
 * @description Hearing Room booking validation schema
 */

const partyShape = Yup.object().shape({
  Name: Yup.string()
    .trim()
    .min(3, "Full name must be at least 3 characters")
    .max(100, "Name is too long")
    .required("Full Name is required"),

  Email: Yup.string()
    .trim()
    .email("Please enter a valid email address")
    .required("Email Address is required")
    .test(duplicateTest("Email", "email address")),

  Phone: Yup.string()
    .trim()
    .matches(
      /^[6-9]\d{9}$/,
      "Enter a valid 10-digit Indian mobile number (starting with 6-9)",
    )
    .required("Phone Number is required")
    .test(duplicateTest("Phone", "phone number")),

  caseReference: Yup.string()
    .trim()
    .max(50, "Case reference is too long")
    .nullable(),
});

const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

const GSTIN_REGEX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

export const bookingValidationSchema = Yup.object().shape({
  hearing_room: Yup.object()
    .nullable()
    .required("Please select a hearing room"),

  hearing_date: Yup.string().required("Please select a hearing date"),

  otp: Yup.string().when("typeOfSelect", {
    is: () => true,
    then: (schema) =>
      schema.length(6, "OTP must be 6 digits").required("OTP is required"),
  }),

  // start_time: Yup.string().required("Please select a start time"),

  start_time: Yup.string()
    .required("Please select a start time")
    .test(
      "valid-time-range",
      "Start time must be between 9:30 AM and 10:00 PM",
      (value) => {
        if (!value) return false;

        const selectedTime = moment(value, "hh:mm A");
        const minTime = moment("09:30 AM", "hh:mm A");
        const maxTime = moment("10:00 PM", "hh:mm A");

        return selectedTime.isBetween(minTime, maxTime, undefined, "[]"); // inclusive
      },
    ),

  session_duration: Yup.string()
    .oneOf(["halfday", "fullday"], "Invalid session duration")
    .required("Please select session duration"),

  numberOfAttendees: Yup.number()
    .min(1, "At least 1 attendee is required")
    .max(50, "Maximum 50 attendees allowed")
    .required("Number of attendees is required"),

  catering: Yup.string()
    .oneOf(["none", "meals", "snacks"], "Invalid catering option")
    .required(),

  typeOfSelect: Yup.string().required(),

  name: Yup.string()
    .trim()
    .when("typeOfSelect", {
      is: "register",
      then: (schema) =>
        schema
          .min(3, "Full name must be at least 3 characters")
          .max(100, "Name is too long")
          .required("Full Name is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

  email: Yup.string()
    .trim()
    .when("typeOfSelect", {
      is: "register",
      then: (schema) =>
        schema
          .email("Please enter a valid email address")
          .required("Email Address is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

  phone: Yup.string()
    .trim()
    .matches(
      /^[6-9]\d{9}$/,
      "Enter a valid 10-digit Indian mobile number (starting with 6-9)",
    )
    .required("Phone Number is required"),

  houseNumber: Yup.string()
    .trim()
    .when("typeOfSelect", {
      is: "register",
      then: (schema) => schema.required("Address is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

  city: Yup.string()
    .trim()
    .when("typeOfSelect", {
      is: "register",
      then: (schema) => schema.required("City is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

  locality: Yup.string()
    .trim()
    .when("typeOfSelect", {
      is: "register",
      then: (schema) => schema.required("Locality is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

  state: Yup.string()
    .trim()
    .when("typeOfSelect", {
      is: "register",
      then: (schema) => schema.required("State is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

  // Contact Information - Mandatory Fields
  contactInformation: Yup.object().shape({
    Name: Yup.string()
      .trim()
      .min(3, "Full name must be at least 3 characters")
      .max(100, "Name is too long")
      .required("Full Name is required"),

    Email: Yup.string()
      .trim()
      .email("Please enter a valid email address")
      .required("Email Address is required"),

    Phone: Yup.string()
      .trim()
      .matches(
        /^[6-9]\d{9}$/,
        "Enter a valid 10-digit Indian mobile number (starting with 6-9)",
      )
      .required("Phone Number is required"),

    caseReference: Yup.string()
      .trim()
      .max(50, "Case reference is too long")
      .nullable(),
  }),

  kind: Yup.string()
    .oneOf(["organization", "individual"])
    .required("Kind is required"),

  documentNumber: Yup.string()
    .when("kind", {
      is: "organization",
      then: (schema) => schema.required("GSTIN is required"),
      otherwise: (schema) => schema.notRequired(),
    })
    .test(
      "document-validation",
      "Invalid PAN / GSTIN format",
      function (value) {
        const { kind } = this.parent;

        if (!value) return kind === "individual";

        if (kind === "individual") {
          return PAN_REGEX.test(value.toUpperCase());
        }

        if (kind === "organization") {
          return GSTIN_REGEX.test(value.toUpperCase());
        }

        return true;
      },
    ),

  // ── Claimants: with within-array duplicate detection ──────────────────────
  claimants_list: Yup.array()
    .of(partyShape)
    .min(1, "At least one claimant is required")
    .required("Claimant information is required"),

  // ── Respondents: with within-array duplicate detection ────────────────────
  respondents_list: Yup.array()
    .of(partyShape)
    .min(1, "At least one respondent is required")
    .required("Respondent information is required"),

  // ── Arbitrators: name-only required, email/phone duplicate-checked ─────────
  arbitrators_list: Yup.array()
    .of(
      Yup.object().shape({
        Name: Yup.string()
          .trim()
          .min(3, "Full name must be at least 3 characters")
          .max(100, "Name is too long")
          .required("Full Name is required"),

        Email: Yup.string()
          .trim()
          .email("Please enter a valid email address")
          .nullable()
          .test(duplicateTest("Email", "email address")),

        Phone: Yup.string()
          .trim()
          .matches(
            /^[6-9]\d{9}$/,
            "Enter a valid 10-digit Indian mobile number (starting with 6-9)",
          )
          .nullable()
          .test(duplicateTest("Phone", "phone number")),
      }),
    )
    .min(1, "At least one arbitrator is required")
    .required("Arbitrator information is required"),

  termsAccepted: Yup.boolean()
    .oneOf([true], "You must accept the terms and conditions")
    .required("You must accept the terms and conditions"),
});

export const reportsValidationSchema = Yup.object({
  fromDate: Yup.date()
    .nullable()
    .when("mode", {
      is: PERIOD_MODES.RANGE,
      then: Yup.date().nullable().required("From date is required"),
      otherwise: Yup.date().nullable().notRequired(),
    }),

  toDate: Yup.date()
    .nullable()
    .when("mode", {
      is: PERIOD_MODES.RANGE,
      then: Yup.date()
        .nullable()
        .required("To date is required")
        .min(
          Yup.ref("fromDate"),
          "To date must be greater than or equal to From date",
        ),
      otherwise: Yup.date().nullable().notRequired(),
    }),

  year: Yup.number()
    .nullable()
    .when("mode", {
      is: (mode) => mode === PERIOD_MODES.YEAR || mode === PERIOD_MODES.MONTH,
      then: Yup.number()
        .typeError("Year is required")
        .required("Year is required"),
      otherwise: Yup.number().nullable().notRequired(),
    }),

  month: Yup.number()
    .nullable()
    .when("mode", {
      is: PERIOD_MODES.MONTH,
      then: Yup.number()
        .typeError("Month is required")
        .required("Month is required"),
      otherwise: Yup.number().nullable().notRequired(),
    }),
});
